import { FOCUS_AREAS, IMAGES } from "@/lib/site";

export default function Focus() {
    return (
        <section
            id="focus"
            data-testid="focus-section"
            className="py-24 md:py-32 lg:py-40 bg-ink text-bone relative overflow-hidden"
        >
            <img
                src={IMAGES.grasses}
                alt=""
                aria-hidden
                className="absolute inset-0 w-full h-full object-cover opacity-[0.12]"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-ink/95 via-ink/85 to-ink/95" />

            <div className="relative max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-12 gap-6 md:gap-12 mb-16 md:mb-20">
                    <div className="col-span-12 md:col-span-7">
                        <span className="number-mark text-ochre">§ 05</span>
                        <h2
                            data-testid="focus-heading"
                            className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02]"
                        >
                            Areas of
                            <br />
                            <em className="italic font-light text-bone/80">
                                focus.
                            </em>
                        </h2>
                    </div>
                    <div className="col-span-12 md:col-span-5 md:pl-12 flex items-end">
                        <p className="text-bone/70 text-lg leading-relaxed max-w-md">
                            Eight interconnected fields of work. Each one
                            strengthens the others — and all of them strengthen
                            Country.
                        </p>
                    </div>
                </div>

                <div
                    data-testid="focus-grid"
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-l border-t border-bone/15"
                >
                    {FOCUS_AREAS.map((f, i) => (
                        <article
                            key={f.title}
                            data-testid={`focus-${i}`}
                            className="border-r border-b border-bone/15 p-8 lg:p-9 group hover:bg-bone/[0.04] transition-colors"
                        >
                            <span className="number-mark text-ochre">
                                — {String(i + 1).padStart(2, "0")}
                            </span>
                            <h3 className="mt-6 font-serif text-2xl md:text-[26px] leading-[1.12] text-bone">
                                {f.title}
                            </h3>
                            <p className="mt-4 text-bone/65 text-[14px] leading-relaxed">
                                {f.body}
                            </p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
